import { HashRouter } from 'react-router-dom';
import { WebgateProvider } from '@xvia/webgate-connect';
import { UiProvider } from '@uigovpe/components';
import { WebgateTokenBridge } from '@/shared/providers/WebgateTokenBridge';
import { ToastProvider } from '@/shared/providers/ToastProvider';
import { AppRoutes } from '@/app/routes';

/**
 * HashRouter, não BrowserRouter: o app é publicado como bundle dentro do
 * Portal PE, sob um basePath que o portal controla. Rota em hash não depende
 * de reescrita no servidor do portal nem quebra se o basePath mudar.
 *
 * WebgateProvider precisa envolver a árvore para que `useWebgate()` funcione
 * — sem ele o contexto cai no valor padrão `{}` e `accessToken` nunca chega
 * ao `WebgateTokenBridge` (bug encontrado nesta mudança: o app nunca estava
 * de fato conectado ao Webgate).
 */
function App() {
  return (
    <WebgateProvider portalUrl={process.env.REACT_APP_PORTAL_URL ?? ''}>
      <UiProvider>
        <WebgateTokenBridge />
        <ToastProvider>
          <HashRouter>
            <main className="cd-content">
              <AppRoutes />
            </main>
          </HashRouter>
        </ToastProvider>
      </UiProvider>
    </WebgateProvider>
  );
}

export default App;
